import { useI18N } from '@yandex-int/i18n/lib/react';
import React from 'react';

import * as keyset from 'i18n/SkillsIndex';
import block from 'propmods';

import { moment } from '../../lib/moment';
import { routes } from '../../lib/routes';
import { OperationEvent } from '../../model/operation';
import { ErrorBoundary } from '../ErrorBoundary/ErrorBoundary';
import Link from '../Link/Link';
import { OperationTypeComponent } from '../statuses/OperationType';

import './Events.scss';

interface Props {
    showHeader?: boolean;
    showSkill?: boolean;
    events: OperationEvent<React.ReactNode>[];
}

const b = block('Events');

export default function Events(props: Props) {
    const i18n = useI18N(keyset);
    return (
        <ErrorBoundary>
            <table {...b(props)} cellSpacing="0">
                {props.showHeader && (
                    <thead>
                        <tr>
                            <th {...b('messageHeader')}>{i18n('table-event')}</th>
                            {props.showSkill && <th {...b('skillHeader')}>{i18n('table-dialog')}</th>}
                            <th {...b('timestampHeader')}>{i18n('table-time')}</th>
                            <th {...b('commentHeader')}>{i18n('table-comment')}</th>
                        </tr>
                    </thead>
                )}
                <tbody>
                    {props.events.map(({ skillEntity, operation }) => {
                        const { channel, id, name } = skillEntity ?? {};

                        return (
                            <tr key={operation.id} {...b('event')}>
                                <td {...b('status')}>
                                    <OperationTypeComponent type={operation.type} channel={channel} />
                                </td>
                                {props.showSkill && (
                                    <td {...b('skill')}>{id ? <Link to={routes.app.skill(id)}>{name}</Link> : name}</td>
                                )}
                                <td {...b('timestamp')}>{moment(operation.createdAt).fromNow()}</td>
                                <td {...b('comment')}>{operation.comment}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </ErrorBoundary>
    );
}
